<!-- prettier-ignore -->

<div class="chat">
  <div class="chat__form-wrapper">
    <chat-header></chat-header>
  </div>

    <div class="chat__history" #scrollContainer>
      <chat-bubble />
      <save-chat-form />
    </div>

  <div class="chat__form-wrapper">
    <recommended-messages/>
    <div class="opacityEffect opacityEffectEnd"></div>

    @if(dataChat.chatIsTyping()){
      <div class="chat__form-wrapper__typing_dot_container">  
        <typing-dots class="chat__dots"  /> 
      </div>
    }
    
    <chat-input-form></chat-input-form>
  </div>
</div>
